import { create } from 'zustand';

/** The Go API requests in flight, so a page can show that it is waiting on the network. */
interface ApiActivityState {
  inFlight: number;
  begin: () => void;
  end: () => void;
}

export const useApiActivityStore = create<ApiActivityState>((set) => ({
  inFlight: 0,
  begin: () => set((state) => ({ inFlight: state.inFlight + 1 })),
  end: () => set((state) => ({ inFlight: Math.max(0, state.inFlight - 1) })),
}));
